/* eslint-disable */

import React, { CSSProperties, SVGAttributes, FunctionComponent } from 'react';
import { getIconColor } from './helper';

interface Props extends Omit<SVGAttributes<SVGElement>, 'color'> {
  size?: number;
  color?: string | string[];
}

const DEFAULT_STYLE: CSSProperties = {
  display: 'block',
};

const IconWaring: FunctionComponent<Props> = ({ size, color, style: _style, ...rest }) => {
  const style = _style ? { ...DEFAULT_STYLE, ..._style } : DEFAULT_STYLE;

  return (
    <svg viewBox="0 0 1024 1024" width={size + 'px'} height={size + 'px'} style={style} {...rest}>
      <path
        d="M512 949C271.038 949 75 752.963 75 512 75 271.038 271.038 75 512 75c240.963 0 437 196.038 437 437 0 240.963-196.037 437-437 437z m0-834c-218.907 0-397 178.093-397 397 0 218.906 178.093 397 397 397 218.906 0 397-178.094 397-397 0-218.907-178.094-397-397-397z"
        fill={getIconColor(color, 0, '#333333')}
      />
      <path
        d="M512 632.329c-13.807 0-25-11.193-25-25v-324c0-13.807 11.193-25 25-25s25 11.193 25 25v324c0 13.807-11.193 25-25 25z"
        fill={getIconColor(color, 1, '#333333')}
      />
      <path
        d="M512 733m-34.074 0a34.074 34.074 0 1 0 68.148 0 34.074 34.074 0 1 0-68.148 0Z"
        fill={getIconColor(color, 2, '#333333')}
      />
    </svg>
  );
};

IconWaring.defaultProps = {
  size: 18,
};

export default IconWaring;
